import { clsx } from 'clsx';
import { Card } from '../card/Card';
import { getArrayFromSize } from '../shared/utils/array';

export function CardListShimmer() {
  return (
    <div>
      {getArrayFromSize(5).map((_, index) => (
        <Card
          key={`${index.toString()}`}
          dataId={index.toString()}
          style={{ height: '78px' }}
          className={clsx('bg-surface-secondary py-4', index !== 0 && 'mt-3')}
        >
          <div
            className='shimmer shimmer-line'
            style={{ width: '100px', height: '10px', marginTop: '8px' }}
          />
          <div
            className='shimmer shimmer-line'
            style={{ width: '300px', height: '10px', marginTop: '10px', marginBottom: '8px' }}
          />
        </Card>
      ))}
    </div>
  );
}
